import React, { FC, useCallback, ChangeEvent } from 'react';
import useMenuActions from 'data/hooks/useMenuActions';
import { statusOptions } from 'model/menu';
import { stopPropagation } from 'utils/onClickHelpers';

import StatusSelect from './styles';
import { Props } from './types';

const ItemStatusSelect: FC<Props> = ({ brandId, itemId, value, ...props }) => {
  const { suspend, unsuspend, isLoading } = useMenuActions();

  const handleChange = useCallback(
    (
      event: ChangeEvent<{
        name?: string | undefined;
        value: unknown;
      }>,
    ) => {
      const newValue = event.target.value as typeof value;

      if (value === newValue) {
        return null;
      }
      if (newValue === 'ACTIVE') {
        unsuspend({ brandId, itemId });
      } else {
        suspend({ brandId, itemId, pauseType: newValue });
      }

      return null;
    },
    [brandId, itemId, value, suspend, unsuspend],
  );

  return (
    <StatusSelect
      disabled={isLoading}
      value={value}
      onChange={handleChange}
      options={statusOptions}
      onClick={stopPropagation}
      {...props}
    />
  );
};

export default ItemStatusSelect;
